export enum LOGIN_TYPE {
  DOCTOR = "DOCTOR",
  EMAIL = "EMAIL",
  PATIENT = "PATIENT",
}
